import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { routeMap } from '@/routes/routeMap';

const ApplicationExistingUser = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('ApplicationExistingUser.title')}>
      <p>{t('ApplicationExistingUser.info')}</p>

      <ModalActions>
        <LinkButton to={routeMap.login.root} onClick={closeModal}>
          {t('ApplicationExistingUser.action')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
};

export default ApplicationExistingUser;
